import { useState } from "react";
import { EyeIcon, PencilSquareIcon, TrashIcon, DocumentChartBarIcon } from "@heroicons/react/24/outline";
import DeleteModal from "./DeleteModal";
import ApplicationModal from "./AddApplicationModal";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { applicationService } from "../services/applicationService";
import toast from "react-hot-toast";
import helpers from "../utils/helpers";
import ApplicationProgressOffCanvas from "./ApplicationProgressOffCanvas";

const TableActions = ({ userRole, item, getAllApplicationList, getAllApplicationForFilter, permission }) => {
  const { user } = useAuth();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [selectedApp, setSelectedApp] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [modelType, setModelType] = useState('')
  const [deleteAppId, setDeleteAppId] = useState({})
  const [openOffCanvas, setOpenOffCanvas] = useState(false)
  const [deleteLoader, setDeleteLoader] = useState(false)
  const isAdmin = userRole?.role_name === 'Admin';

  const navigate = useNavigate();

  // View handler
  const handleView = (id) => {
    const cryptId = helpers.encryptId(id)
    navigate(`/applications/${cryptId}`); // 👈 This should match your route
  };

  // Delete handler
  const handleDelete = async () => {
    try {
      setDeleteLoader(true)
      let data = JSON.stringify({
        'id': deleteAppId?.application_id.toString()
      })
      const response = await applicationService.deleteApplication(data)
      if (response?.success == true) {
        setDeleteLoader(false)
        toast.success(response?.message || 'Application deleted successfully')
        await getAllApplicationList()
        await getAllApplicationForFilter()
        setDeleteAppId({})
        setIsDeleteOpen(false);
      } else {
        setDeleteLoader(false)
        setDeleteAppId({})
        setIsDeleteOpen(false)
        // toast.error(response?.message)
      }
    } catch (e) {
      setDeleteLoader(false)
      setDeleteAppId({})
      setIsDeleteOpen(false)
      toast.error(e.response.data.message || 'Something went wrong')
    }
  };

  // Save handler
  // const handleSave = (values, isEdit) => {
  //   if (isEdit) {
  //     console.log("Updating app...", values);
  //     // call API update
  //   } else {
  //     console.log("Adding new app...", values);
  //     // call API add
  //   }
  //   setModalOpen(false);
  // };

  return (
    <>
      <td className="py-4 px-3 flex gap-2 text-gray-500">
        {permission?.view === true &&
          <EyeIcon
            className="w-5 h-5 cursor-pointer text-grey-600 hover:font-800"
            onClick={() => handleView(item?.application_id)}
          />
        }
        {
          permission?.updateApplicationProgress === true &&
          <DocumentChartBarIcon
            className="w-5 h-5 cursor-pointer text-grey-600 hover:font-800"
            onClick={() => setOpenOffCanvas(true)}
          />
        }
        {permission?.edit === true &&
          <PencilSquareIcon
            className="w-5 h-5 cursor-pointer text-brandBlue hover:font-800"
            onClick={() => {
              setSelectedApp(item);
              setModalOpen(true);
              setModelType('Edit')
            }}
          />
        }
        {permission?.deleteSingle === true &&
          < TrashIcon
            className="w-5 h-5 cursor-pointer text-red-600 hover:font-800"
            onClick={() => { setIsDeleteOpen(true); setDeleteAppId(item) }}
          />
        }
      </td>

      {permission?.deleteSingle === true &&
        <DeleteModal
          isOpen={isDeleteOpen}
          onClose={() => { setIsDeleteOpen(false); setDeleteAppId({}) }}
          onConfirm={handleDelete}
          title='Delete'
          deleteLoader={deleteLoader}
        />
      }
      {permission?.edit === true &&
        <ApplicationModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          type={modelType}
          selectedApp={selectedApp}
          setSelectedApp={setSelectedApp}
          setModelType={setModelType}
          getAllApplicationList={() => { getAllApplicationList(); getAllApplicationForFilter() }}
        />
      }
      {permission?.updateApplicationProgress === true &&
        <ApplicationProgressOffCanvas openOffCanvas={openOffCanvas} setOpenOffCanvas={setOpenOffCanvas} />
      }
    </>
  );
};

export default TableActions;
